module.exports = __webpack_public_path__ + "img/magento-setup-tuning@2x.2c771917.jpeg";